import React from 'react';
import './Jetaway.css';
import Footer from '../Shared/Footer/Footer';
import Navbar from '../Shared/Navbar/Navbar';
import jet1 from '../../assets/images/work-1.png';
import jet2 from '../../assets/images/jetaway/2.png';
import jet3 from '../../assets/images/jetaway/3.jpg';

const Jetaway = () => {
    return (
        <div>
            <Navbar />
            <div style={{ marginTop: '100px' }} className='container'>
                <h1 className='main-title text-center'>Jetaway Web <br /> Application</h1>
                <p className='main-info text-center'>Travel Service | Full Stack Application</p>
                <p className='main-info main-links text-center'><a target='_blank' href="https://github.com/mishrahat/jetaway-app-client-side">Client-Side Code</a> | <a target='_blank' href="https://github.com/mishrahat/jetaway-app-server-side">Server-Side Code</a> | <a target='_blank' href="https://jetaway.netlify.app/">Live Site</a></p>
                <img className='w-100 img-fluid img-thumbnail' src={jet1} alt="" />
                <div className='row mt-4'>
                    <div className='col-lg-6 photos'>
                        <img style={{ width: '250px', marginLeft: '200px' }} className='img-fluid img-thumbnail' src={jet3} alt="" />
                    </div>
                    <div className='col-lg-6 photos'>
                        <img style={{ width: '550px' }} src={jet2} alt="" />
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className='col-lg-6 overview'>
                        <h2 style={{ marginLeft: '200px' }}>Project Overview</h2>
                        <p className='work-info' style={{ marginLeft: '200px' }}>Jetaway is a Full Stack Web Application Project. Here the user will be able to look for various travel packages and also they can see what they have booked and can delete it.</p>
                    </div>
                    <div className='col-lg-6'>
                        <h2 className='key-points'>Key Points</h2>
                        <ul>
                            <li className='work-info'>Used MERN stack for this particular project.</li>
                            <li className='work-info'><span className='side-site'>Front-End:</span> Bootstrap, React JS, React Hook,
                                Context API, REST API, JSON
                            </li>
                            <li className='work-info'><span className='side-site'>Back-End:</span> Node JS, Express JS</li>
                            <li className='work-info'><span className='side-site'>Database:</span> MongoDB</li>
                            <li className='work-info'><span className='side-site'>Tools:</span> Git, Github, Heroku, Netlify, Firebase.</li>
                        </ul>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Jetaway;